import { DatePicker } from "antd";
import isEqual from "lodash/isEqual";
import { useState } from "react";

import FilterDropdownWrapper from "@/components/Elements/Filters/FilterDropdownWrapper";
import { FilterDropdownAttributes } from "@/components/Elements/Filters/Filters.type";
import { DAYSJS_DEFAULT_DATE_FORMAT } from "@/services/dayjs";

import {
  getSelectedKeys,
  getRangerPickerValue,
} from "./DateRangeFilterDropdown.service";

const { RangePicker } = DatePicker;

const DEFAULT_VALUE = [null, null]; // default = reset filter

// https://4x.ant.design/components/table/#components-table-demo-custom-filter-panel
const DateRangeFilterDropdown = (filterProps) => {
  const { selectedKeys, setSelectedKeys, confirm } = filterProps;
  const defaultRange = getRangerPickerValue(selectedKeys ?? DEFAULT_VALUE);

  const [rangeValue, setRangeValue] = useState(defaultRange);

  const onRangeChange = (value) => {
    setRangeValue(value);
  };

  const onResetClick = () => {
    setRangeValue(DEFAULT_VALUE);
  };

  const onOkClick = () => {
    const keys = getSelectedKeys(rangeValue, DAYSJS_DEFAULT_DATE_FORMAT);
    setSelectedKeys(keys);
    confirm();
  };

  const onDropdownClose = () => {
    // When dropdown is hidden, reset state to selectedKeys to make sure state
    // is always synced.
    setRangeValue(defaultRange);
  };

  return (
    <FilterDropdownWrapper
      filterProps={filterProps}
      okButtonProps={{ onClick: onOkClick }}
      resetButtonProps={{
        onClick: onResetClick,
        disabled: isEqual(rangeValue, DEFAULT_VALUE),
      }}
      onDropdownClose={onDropdownClose}
    >
      <RangePicker
        value={rangeValue}
        onChange={onRangeChange}
        format={DAYSJS_DEFAULT_DATE_FORMAT}
      />
    </FilterDropdownWrapper>
  );
};

DateRangeFilterDropdown.propTypes = FilterDropdownAttributes;

export default DateRangeFilterDropdown;
